import Wrapper from '@app/Wrapper.js'

Munio.CoursePlayer = class CoursePlayer extends Wrapper {
  constructor(selector, { attemptId, isPreview, backUrl }) {
    super(selector, {
      attemptId,
      isPreview,
      backUrl,
    })
  }

  component() {
    return import('./course/App.vue')
  }
}

Munio.QuizPlayer = class QuizPlayer extends Wrapper {
  constructor(selector, { attemptId, nodeId, language, model, playback }) {
    super(selector, {
      attemptId,
      nodeId,
      language,
      model,
      playback,
    })
  }

  component() {
    return import('./quiz/App.vue')
  }
}
